import { Modal, Button } from "react-bootstrap";
import { useRecoilValue, useRecoilState } from "recoil";
import { isModalAtom, usersAtom } from "../../atoms";

function UserModal() {
  //모달 닫기 제어
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const handleClose = () => setisMocalopen(false);
  const authdata = useRecoilValue(usersAtom);

  return (
    <>
      <Modal.Header>
        <Modal.Title>User Info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{JSON.stringify(authdata)}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn_close" variant="secondary" onClick={handleClose}>
          닫기
        </Button>
      </Modal.Footer>
    </>
  );
}

export default UserModal;
